module.exports = {"pathContext":{"name":"StockTransferFulfillmentItemStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COLLECTED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DRAFT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"READY"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-stock-transfer-fulfillment-item-status.json
// module id = 1314
// module chunks = 29319016969055